// extracted by mini-css-extract-plugin
export default {"adminContent":"AdminPage_adminContent__hwedp"};